"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setCookie = setCookie;
function setCookie(name, value, expirationAsUTCString) {
  var expiration = expirationAsUTCString ? "; expires=".concat(expirationAsUTCString) : "";
  var currentUrl = new URL(window.location.href);
  var urlParts = currentUrl.hostname.split(".");
  var domainWithoutSubdomain = urlParts.slice(-2).join(".");
  document.cookie = "".concat(name, "=").concat(value || "").concat(expiration, "; Secure; path=/; domain=").concat(domainWithoutSubdomain);
}